"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PopupFilterResults = void 0;
var react_1 = __importDefault(require("react"));
var InlineIcon_1 = require("./InlineIcon");
var TextButton_1 = require("./TextButton");
var GroupsFilterList = function (_a) {
    var options = _a.options, onChange = _a.onChange;
    return (react_1.default.createElement("div", { className: "mt-1" }, options
        .filter(function (o) { return o.selected; })
        .map(function (o) { return (react_1.default.createElement("div", { key: o.key },
        react_1.default.createElement(TextButton_1.TextButton, { onClick: function () {
                o.selected = false;
                onChange(options);
            } },
            react_1.default.createElement(InlineIcon_1.InlineIcon, { className: "w-3", name: "close" })),
        o.value)); })));
};
exports.PopupFilterResults = GroupsFilterList;
